/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-08-22 15:00:00
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import * as installActions from 'actions/install-actions';
import { getShop } from 'src/helpers';

type Props = WithI18nProps;

class SyncTrigger extends Component<Props> {
  state = {
    alertedNotify: false
  };

  componentDidMount() {
    const { getInstallStatus } = this.props;
    getInstallStatus();
  }

  componentWillReceiveProps(nextProps) {
    const isTriggeredSlowSync = !!localStorage.getItem(`${getShop()}--isTriggeredSlowSync`);

    const syncProgress = nextProps.syncProgress;

    // Continue to get status if there is no error or hanging
    if (
      nextProps.loading === false &&
      +syncProgress < 1 &&
      nextProps.syncInfoStatus !== 'error' &&
      nextProps.syncInfoStatus !== 'done'
    ) {
      const { getInstallStatus, alertSlowInstallation } = this.props;
      setTimeout(async () => {
        if (!isTriggeredSlowSync) {
          const installStatusResponse = await getInstallStatus();
          const syncStatus = _.get(installStatusResponse, 'payload.data.syncStatus', {});
          const startedAt = parseInt(_.get(syncStatus, 'startedAt', 0));
          const now = new Date().getTime() / 1000;
          const currentDuration = now - startedAt;
          const { alertedNotify } = this.state;

          if (
            this.getTimeStayByTotalProduct() > 0 &&
            currentDuration >= this.getTimeStayByTotalProduct() &&
            !alertedNotify
          ) {
            this.setState({ alertedNotify: true }, () => {
              localStorage.setItem(`${getShop()}--isTriggeredSlowSync`, true);
              //call api trigger notify
              alertSlowInstallation({ currentDuration: Math.floor(currentDuration) });
            });
          }
        }
      }, 5000);
    }
  }

  render() {
    return <></>;
  }

  getTimeStayByTotalProduct = () => {
    const { currentTotalProducts, tenantApp } = this.props;

    const tenantId = _.get(tenantApp, 'tenantId', '');
    if (
      tenantId === 'bc-dev-v2-dustin5.myshopify.com' ||
      tenantId === 'bc-dev-v2-dustin3.myshopify.com' ||
      tenantId === 'bc-dev-v2-dustin2.myshopify.com'
    ) {
      if (currentTotalProducts >= 10 && currentTotalProducts <= 10000) {
        return 30;
      }
      if (currentTotalProducts > 10000) {
        return 1;
      }
      return -1;
    }

    if (currentTotalProducts >= 1000 && currentTotalProducts < 2000) {
      return 5 * 60;
    }
    if (currentTotalProducts >= 2000 && currentTotalProducts < 5000) {
      return 10 * 60;
    }
    if (currentTotalProducts >= 5000 && currentTotalProducts < 10000) {
      return 20 * 60;
    }
    if (currentTotalProducts > 10000) {
      return 1;
    }
    return -1;
  };
}

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const currentTotalProducts = _.get(tenantApp, 'appParams.currentTotalProducts', 0);
  return {
    tenantApp: _.get(state, 'oauth.tenantApp', null),
    currentTotalProducts,
    loading: state.install.loading,
    installStatus: state.install.installStatus,
    syncInfoStatus: state.install.syncStatus,
    installSyncPercent: state.install.installSyncPercent,
    syncProgress: state.install.syncProgress,
    installSetupThemePercent: state.install.installSetupThemePercent,
    installStep: state.install.installStep,
    installTotal: state.install.installTotal,
    installCurrentStep: state.install.installCurrentStep,
    installThemeId: state.install.installThemeId,
    installThemeName: state.install.installThemeName,
    installThemeUpdatedAt: state.install.installThemeUpdatedAt
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getInstallStatus: () =>
    dispatch(
      installActions.getInstallStatus(ownProps.i18n, { queries: { t: 'trigger-sync-info' } })
    ),
  alertSlowInstallation: data => dispatch(installActions.alertSlowInstallation(data))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(SyncTrigger));
